// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"58a0c106","532":"e1195930","564":"0a2e392c","727":"8becad37"}[chunkId] + ".chunk.css";
};